<template>
  <div>
    <!--<div class="trading-floating-btn" @click="tradingasplan">WTS 체험
    </div>-->
    <router-link to="contact" class="contact-floating-btn">
      <img src="@/assets/icons/icon-mail.svg" alt="" />
      Contact us
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ContactFloatingBtn',

  data() {
    return {};
  },

  mounted() { },

  methods: {
    tradingasplan() {
      window.open("https://tradingasplan.com", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped></style>
